// extracted by mini-css-extract-plugin
export default {"paymentSection":"a5-z","disabled":"b5-z"};